import { LoginAdapterInterface } from "@citychallenge/core";

export const LoginAdapter: LoginAdapterInterface = {
  configureGoogleLogin: () => null,
  googleLogin: () => {
    throw new Error("Not implemented");
  },
  facebookLogin: () => {
    throw new Error("Not implemented");
  },
  appleLogin: () => {
    throw new Error("Not implemented");
  },
};
